var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"divide"}),_c('div',{staticClass:"con clearfix"},[_c('div',{staticClass:"con-left"},[_c('span',[_vm._v("  "),_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.title))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }